__turbopack_context__.v({
  "bonus": "TicketEntry-module__bn-Lka__bonus",
  "container": "TicketEntry-module__bn-Lka__container",
  "number": "TicketEntry-module__bn-Lka__number",
  "numberInner": "TicketEntry-module__bn-Lka__numberInner",
  "numbersOverlay": "TicketEntry-module__bn-Lka__numbersOverlay",
  "ticketImage": "TicketEntry-module__bn-Lka__ticketImage",
  "ticketImageLoaded": "TicketEntry-module__bn-Lka__ticketImageLoaded",
});
